export default {"src":"/_next/static/media/SCALIS_LOGO_BLUE.933e93b9.svg","height":50,"width":170,"blurWidth":0,"blurHeight":0};